module.exports = __webpack_public_path__ + "app/assets/images/woman10-2f425c743d8734a297e01f1c24da5ecc.jpg";